var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3673 6.1049C1.49301 5.4934 1.82571 4.94394 2.3093 4.54913C2.79289 4.15433 3.39781 3.93831 4.02209 3.9375H16.9779C17.6164 3.93891 18.2338 4.16585 18.7212 4.57827C19.2085 4.99068 19.5345 5.56204 19.6416 6.19146L10.5029 9.79342L1.3673 6.1049ZM10.7406 11.1103C10.5843 11.1721 10.4101 11.1714 10.2542 11.1083L1.3125 7.49818V14.3529C1.31328 15.0713 1.59901 15.76 2.10698 16.268C2.61496 16.776 3.3037 17.0617 4.02209 17.0625H16.9779C17.6963 17.0617 18.385 16.776 18.893 16.268C19.401 15.76 19.6867 15.0713 19.6875 14.3529V7.58376L10.7406 11.1103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.3eb80f4dcc3c43fd74bf52a3d3d9937d.svg";
export { ForwardRef as ReactComponent };